<template lang="pug">
  ol
    li.form-control-static.text-prewrap(v-for="(keyword, index) in value", :key="index" data-testid="-pvkeyword") {{keyword || app_lang.NO_INPUT}}
</template>

<script>
export default {
  name: 'PvKeywordsView',
  props: {
    value: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/molecules/PvKeywordsView.vue